import "./index.css"
import DP from "../../components/custom/dp"
import Icon from "../../components/custom/icon"
import { useGlobal } from "../../context/global"

const Chrome = () => {

    const { deviceInfo } = useGlobal()

    const copyLink = () => {
        const text = 'https://sevabase.iskconmysore.org'
        navigator.clipboard.writeText(text)
            .then(() => {
                alert('Link copied to clipboard!')
            })
            .catch(err => {
                console.error('Failed to copy: ', err)
            })
    }

    return (
        <div className="chrome-home">
            <div className="chrome-root">
                <div className="chrome-icons">
                    <DP className={'chrome-fav'} url="/favicon.png" size={[25, 10]} />
                    <DP url="/chrome.png" size={[25, 10]} />
                </div>


                <div className="chrome-title">
                    {"This app works best with\nGoogle Chrome"}
                </div>

                <div className="chrome-desc">
                    For optimal performance and features, we recommend using Google Chrome to access this application.
                </div>

                <div className="chrome-instruction">
                    {"If you have Google Chrome already installed in your device, copy the URL below and open in Chrome"}
                </div>

                <div className="chrome-copy-box" onClick={copyLink}>
                    <div className="chrome-copy-url">https://sevabase.iskconmysore.org</div>
                    <Icon name="copy" />
                </div>

                <div className="chrome-instruction">
                    If you do not have Google Chrome installed, click on download button below
                </div>

                <a
                    target="_blank"
                    href={
                        deviceInfo.os == 'Android'
                            ? "https://play.google.com/store/apps/details?id=com.android.chrome"
                            : (deviceInfo.os == 'iOS'
                                ? 'https://apps.apple.com/app/google-chrome/id535886823'
                                : 'https://www.google.com/chrome/')
                    }
                    className="chrome-download-btn"
                >
                    Download Chrome
                </a>
            </div>
        </div>
    )
}

export default Chrome
